import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div``;

export const HandleInput = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2vh;

`;
export const Input = styled.input`
  width: 80%;
  border: none;
  background-color: ${theme.colors.light};
  border-radius: 0.25rem;
 color: ${theme.colors.dark};
  padding: 1vh 2vw;
  font-size: max(8px, 1vw);
`;
export const HandleButton = styled.div`
  display: flex;
  justify-content: space-around;
`;

export const Button = styled.button`
  padding: 1vh 2vw;
  font-size: max(8px, 1vw);
  color: ${theme.colors.dark};
  border-radius: 0.25rem;
  background-color: ${theme.colors.darkGrey};
  &:hover {
      opacity: 0.8;
  }

`;
